// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"546":"0f028d43","629":"d7261a39"}[chunkId] + ".chunk.js";
};